import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import AutocompleteField from '@components/Form/AutocompleteField';
import DropdownField from '@components/Form/DropdownField';
import { useEntitiesCreate } from '@hooks';
import { BLANK_OPTION, BLANK_RECORD_OPTION } from '@src/constants';
import { autocompleteEntities } from '@utils/backend-api/entities';
import {
  ENTITY_TYPE_SUB_JOB_FUNCTION,
  ENTITY_WORD_TYPE_COMMON,
  PROFILE_FIELD_OTHER_VALUE,
  PROFILE_OTHER_OPTION,
} from '@utils/backend-api/profileSettings';

import { StepProfileFormProps } from '../StepProfile';
import subJobFunctionList from './SubJobFunctionList';

const SubJobFunctionFields = () => {
  const { values, setFieldValue, initialValues } = useFormikContext<StepProfileFormProps>();
  const { mutateAsync: createEntityAsync } = useEntitiesCreate();

  useEffect(() => {
    if (values.jobFunction.value === PROFILE_FIELD_OTHER_VALUE) {
      setFieldValue('subJobFunction', PROFILE_OTHER_OPTION);
      setFieldValue(
        'customSubJobFunction',
        initialValues.customSubJobFunction.value
          ? initialValues.customSubJobFunction
          : { ...BLANK_RECORD_OPTION }
      );
    } else if (initialValues.jobFunction.value !== values.jobFunction.value) {
      setFieldValue('subJobFunction', BLANK_OPTION);
      ['customJobFunction', 'customSubJobFunction'].forEach((field) => {
        setFieldValue(field, BLANK_RECORD_OPTION);
      });
    }
  }, [
    values.jobFunction.value,
    initialValues.jobFunction.value,
    initialValues.customSubJobFunction.value,
    initialValues,
    setFieldValue,
  ]);

  const showCustomField =
    values.subJobFunction.value === PROFILE_FIELD_OTHER_VALUE &&
    ((values.jobFunction.value === PROFILE_FIELD_OTHER_VALUE && !!values.customJobFunction.value) ||
      values.jobFunction.value !== PROFILE_FIELD_OTHER_VALUE);

  return (
    <>
      <DropdownField
        name="subJobFunction"
        options={subJobFunctionList[values.jobFunction.value] || []}
        isDisabled={
          !values.jobFunction.value ||
          (values.jobFunction.value === PROFILE_FIELD_OTHER_VALUE &&
            !values.customJobFunction.value)
        }
        label="Sub-Job Function&#42;"
        placeholder="Select"
        isClearable={false}
      />
      {showCustomField && (
        <div className="mt-4">
          <AutocompleteField
            name="customSubJobFunction"
            fetchMethod={(value) =>
              autocompleteEntities({
                fragment: value,
                entity_type: ENTITY_TYPE_SUB_JOB_FUNCTION,
              })
            }
            createMethod={(value) =>
              createEntityAsync({
                name: value,
                entity_type: ENTITY_TYPE_SUB_JOB_FUNCTION,
                word_type: ENTITY_WORD_TYPE_COMMON,
              })
            }
          />
        </div>
      )}
    </>
  );
};

export default SubJobFunctionFields;
